export default {
  destinationSearchAiMatching: {
    errorMsg: {
      peopleIsNumber: '利用人数は数字で入力してください',
      multiplePeople: '複数人で利用を選択しています。<br />利用人数は2人以上にしてください',
    },
    category: {
      area: '空間',
      user: 'ユーザー',
    },
    category_min: {
      area: '空間',
      user: '人',
    },
    purposes: [
      {
        key: 'kouritu',
        label: '効率をあげたい'
      },
      {
        key: 'giron',
        label: '議論をしたい'
      },
      {
        key: 'relax',
        label: 'リラックスしたい'
      },
      {
        key: 'reflesh',
        label: '気分転換したい'
      },
    ],
    locations: [
      {
        key: 'inside',
        label: '屋内'
      },
      {
        key: 'outside',
        label: '屋外'
      },
      {
        key: null,
        label: 'こだわらない'
      }
    ],
    personTypes: [
      {
        key: 'single',
        label: '1人で利用',
      },
      {
        key: 'multiple',
        label: '複数人で利用',
      }
    ],
    options: [
      {
        key: 'private',
        label: '個室',
      },
      {
        key: 'open',
        label: 'オープン',
      },
      {
        key: 'showMtFuji',
        label: '富士山が見える',
      },
      {
        key: 'cool',
        label: '涼しい',
      },
      {
        key: 'warm',
        label: '暖かい',
      },
      {
        key: 'quiet',
        label: '人が少ない',
      },
      {
        key: 'bustling',
        label: 'にぎわっている',
      },
      {
        key: 'bright',
        label: '明るい',
      },
      {
        key: 'dark',
        label: '暗い',
      },
    ],
  },

  area: [
    {
      id: 1,
      name: 'TAC.T TERRACE / CAFE',
    },
    {
      id: 2,
      name: 'TAC.T OFFICE',
    },
    {
      id: 3,
      name: '人と空間のラボ 1F',
    },
  ],

  visualizationLayers: [
    {
      value: 'default',
      name: 'デフォルト',
      image: require('@/assets/images/icon-visualization-default.svg'),
    },
    {
      value: 'setstar',
      name: '体感温度',
      image: require('@/assets/images/icon-visualization-setstar.svg'),
    },
    {
      value: 'sound',
      name: 'にぎわい度',
      image: require('@/assets/images/icon-visualization-bustling.svg'),
    },
//    {
//      value: 'congestion',
//      name: '混雑分布',
//      image: require('@/assets/images/icon-visualization-congestion.svg'),
//    },
  ],

  // TODO: update Group name and image
  visualizationLayerGroups: [
    {
      value: 'Group1',
      name: 'Group 1',
      layoutClass: 'group1-layout',
      image: require('@/assets/images/icon-visualization-setstar.svg'),
      visualizationLayerTypes: ['light'],
    },
    {
      value: 'Group2',
      name: 'Group 2',
      layoutClass: 'group2-layout',
      image: require('@/assets/images/icon-visualization-bustling.svg'),
      visualizationLayerTypes: ['temperature'],
    },
    {
      value: 'Group3',
      name: 'Group 3',
      layoutClass: 'group3-layout',
      image: require('@/assets/images/icon-visualization-bustling.svg'),
      visualizationLayerTypes: ['humidity'],
    },
    {
      value: 'Group4',
      name: 'Group 4',
      layoutClass: 'group4-layout',
      image: require('@/assets/images/icon-visualization-congestion.svg'),
      visualizationLayerTypes: ['eco2', 'sound', 'wind_speed'],
    },
  ],

  // TODO: update minValue, maxValue, colors
  visualizationHeaders: {
    light: {
      label: '照度',
      unit: 'lx',
      minValue: 0,
      maxValue: 551,
      colors: [
        '#cbcbcb',
        '#d0cdb9',
        '#d4d0a6',
        '#d9d294',
        '#ded481',
        '#e3d66f',
        '#e7d95c',
        '#ecdb4a',
        '#f1dd37',
        '#f6df25',
        '#fae212',
        '#ffe400',
      ]
    },
    temperature: {
      label: '温度',
      unit: '℃',
      minValue: 0,
      maxValue: 40,
      colors: [
        '#0000ff',
        '#0066ff',
        '#00ccff',
        '#00ffff',
        '#4cffc1',
        '#99ff66',
        '#ccff33',
        '#ffff00',
        '#ffdd00',
        '#ffb300',
        '#ff8c00',
        '#ff6600',
        '#ff4000',
        '#ff1500',
        '#e60000',
        '#ff0000',
      ]
    },
    humidity: {
      label: '湿度',
      unit: '%',
      minValue: 20,
      maxValue: 70,
      colors: [
        '#E6F7FF',
        '#CFF0FF',
        '#B8E9FF',
        '#A1E2FF',
        '#8ADBFF',
        '#73D4FF',
        '#5CCEFF',
        '#45C7FF',
        '#2EC0FF',
        '#17B9FF',
        '#00B2FF',
      ]
    },
    eco2: {
      label: 'CO2',
      unit: 'ppm',
      minValue: 400,
      maxValue: 2000,
      colors: [
        '#0000ff',
        '#0055ff',
        '#00abff',
        '#00fffe',
        '#11eeba',
        '#22dd75',
        '#33cd32',
        '#55d629',
        '#77de21',
        '#9ae619',
        '#bcef10',
        '#def708',
        '#fffc00',
        '#ffbc00',
        '#ff7c00',
        '#ff3c00',
        '#ff0000',
      ]
    },
    sound: {
      label: '音',
      unit: 'dB',
      minValue: 0,
      maxValue: 60,
      colors: [
        '#00ccff',
        '#00ffff',
        '#4cffc1',
        '#99ff66',
        '#ccff33',
        '#ffff00',
      ]
    },
    wind_speed: {
      label: '気流',
      unit: 'm/s',
      minValue: 0,
      maxValue: 0.5,
      colors: [
        '#fffdd0',
        '#ebf3d9',
        '#d6e9e3',
        '#c2e0ec',
        '#add6f6',
        '#98cbff',
        '#7aa3ff',
        '#5b7aff',
        '#3d52ff',
        '#1e28ff',
        '#0000ff',
      ]
    },
  },

  userProfile: {
    gender: {
      male: {
        key: 'male',
        label: '男性',
      },
      female: {
        key: 'female',
        label: '女性',
      },
    },
    favoriteEnvironments: {
      temperatureLevel: {
        name:'温冷感',
        selectables: {
          0: '涼しい',
          1: '少し涼しい',
          2: '普通',
          3: '少し暖かい',
          4: '暖かい',
        }
      },
      airFlowLevel: {
        name: '気流',
        selectables: {
          0: 'なし',
          1: '弱い',
          2: '普通',
          3: '強い',
        }
      },
      lightBrightnessLevel: {
        name:'明るさ',
        selectables: {
          0: '暗い',
          1: '少し暗い',
          2: '普通',
          3: '少し明るい',
          4: '明るい',
        }
      },
    },
  },

  // NOTE: 検索結果の詳細に表示する環境の情報
  // TODO: 最大値・最小値を決める
  env: {
    congestion: {
      min: 0,
      max: 10,
    },
    sound: {
      min: 0,
      max: 100,
    },
    bodyTemperature: {
      min: 0,
      max: 50,
    },
    temperature: {
      min: 0,
      max: 50,
    },
    humidity: {
      min: 0,
      max: 100,
    },
    windSpeed: {
      min: 0,
      max: 10,
    },
  },

  zoomLevel: {
    8: { // NOTE: 2m ~ 5m
      thresholda: 2,
    },
    7: { // NOTE: 5m ~ 10m
      thresholda: 5,
    },
    6: { // NOTE: 10m ~ 20m
      thresholda: 10,
    },
    5: { // NOTE: 20m ~ 50m
      thresholda: 20,
    },
    4: { // NOTE: 50m ~ 100m
      thresholda: 50,
    },
    3: { // NOTE: 100m ~ 200m
      thresholda: 100,
    },
    2: { // NOTE: 200m ~ 500m
      thresholda: 200,
    },
    1: { // NOTE: 500m ~
      thresholda: 500,
    },
  },

  feedback: {
    'temperature': {
      title: '温冷感',
      min: -2,
      max: 2,
      minLabel: '寒すぎ',
      maxLabel: '熱すぎ',
      centerLabel: 'ちょうど良い',
    },
    'airFlow': {
      title: '気流',
      min: -2,
      max: 2,
      minLabel: '弱すぎ',
      maxLabel: '強すぎ',
      centerLabel: 'ちょうど良い',
    },
    'lightBrightness': {
      title: '明るさ',
      min: -2,
      max: 2,
      minLabel: '暗すぎ',
      maxLabel: '明るすぎ',
      centerLabel: 'ちょうど良い',
    },
    'lightColor': {
      title: '光の色味',
      min: -2,
      max: 2,
      minLabel: '黄すぎ',
      maxLabel: '白すぎ',
      centerLabel: 'ちょうど良い',
    },
  },

  destination: {
    spot: {
      spotTypes: [
        { key: 'Spot::OpenSpot', name: 'オープンスペース' },
        { key: 'Spot::PrivateSpot', name: '会議室' },
        { key: 'Spot::Dome', name: 'ドーム' },
      ],
    },
    restroom: {
      genders: [
        { key: 'male', name: '男子トイレ' },
        { key: 'female', name: '女子トイレ' },
        { key: 'shared', name: 'だれでもトイレ' },
      ],
    }
  },

  week: {
    'sunday': {
      name: '日曜日',
      value: 0,
    },
    'monday': {
      name: '月曜日',
      value: 1,
    },
    'tuesday': {
      name: '火曜日',
      value: 2,
    },
    'wednesday': {
      name: '水曜日',
      value: 3,
    },
    'thursday': {
      name: '木曜日',
      value: 4,
    },
    'friday': {
      name: '金曜日',
      value: 5,
    },
    'saturday': {
      name: '土曜日',
      value: 6,
    },
  }

}



// WEBPACK FOOTER //
// ./src/config.js